import React, { useContext } from 'react';
import { Modal } from '@utex/ui-kit';
import { MainModal } from '../MainModal';

import { ModalContext, Modals } from '../../../../modalsContext';

import { DoneModal } from '../../../DepositStatusModal/components/DoneModal';
import { DownloadModal } from '../../../DepositStatusModal/components/DownloadModal';

export const CurrentModal = () => {
  const { currentOpenModal, onRequestClose } = useContext(ModalContext);

  switch (currentOpenModal) {
    case Modals.DONE:
      return <DoneModal onRequestClose={onRequestClose} onButtonClick={onRequestClose} />;
    case Modals.DOWNLOAD:
      return <DownloadModal onRequestClose={onRequestClose} onButtonClick={onRequestClose} />;
    case Modals.MAIN:
    default:
      return (
        <Modal isOpen={true} size={960} onRequestClose={onRequestClose} testId="deposit-modal">
          <MainModal />
        </Modal>
      );
  }
};
